(function($){
  $(function(){

    var $psf = $('.site-footer--parallax .site-footer');
    $(window).bind('scroll',function(){
      if ($(window).scrollTop() < 0) {
        $psf.addClass('off');
      } else if ($psf.hasClass('off')) {
        $psf.removeClass('off');
      }
	});

    if( $('.arbox-wrap').length > 0 ) {
        BlockArranger( { classPrefix:'arbox', padding:2, switchPoint:[ [0, 1], [550, 2], [1000, 3] ] } );
    }

    if( $('.faq').length > 0 ) {
        $('.faq dt').on( "click", function(){ $(this).next().slideToggle("fast"); } );
    }

    $('.mailto').each(function(index,element){
        var user = $(this).attr('data-user');
        var domain = '';
        switch( $(this).attr('data-site') ){
          	case 'ouestvillage':
				domain = 'ouestvillage.com';
            break;
            case 'ileavacom':
                domain = 'ileava.com';
            break;
            case 'ileavajp':
                domain = 'ileava.jp';
            break;
         }
        $(this).append( $('<a>').attr('href','mailto:' + user + '@' + domain ).html( user + '@' + domain ) );
    });
  });


  //add or buy now
  $(document).on('click','.product-form button',function(){
    var item_label = $(this).closest('.product-form').attr('data-sku');
    if (typeof gtag !== 'undefined') {
      gtag('event', 'Cart', {'event_category': 'Cart', 'event_action': 'Added Item', 'event_label': 'Added ' + item_label});
    }
  });

  //click Instafeed
  $(document).on('click','#insta-feed a',function(){
    if (typeof gtag !== 'undefined') {
      gtag('event', 'Instafeed', {'event_category': 'Instafeed', 'event_action': 'Click Instafeed'});
    }
  });

  //Share
  $(document).on('click','.ile-share-buttons a',function(){
    if (typeof gtag !== 'undefined') {
    	gtag('event', 'Share', {'event_category': 'Share', 'event_action': $(this).attr('data-action'), 'event_label': $(this).attr('data-label')});
    }
  });

  //Newsletter
  $(document).on('click','.btn--newsletter__submit',function(){
    if (typeof gtag !== 'undefined') {
    	gtag('event', 'Newsletter', {'event_category': 'Newsletter', 'event_action': 'Subscribe', 'event_label': 'Subscribe:'+location.href});
    }
  });

  //Contact
  $(document).on('click','.ile-contact-submit',function(){
    if (typeof gtag !== 'undefined') {
    	gtag('event', 'Contact', {'event_category': 'Contact', 'event_action': 'Send Contact', 'event_label': document.referrer});
    }
  });


  if ($('.ile-custom-showhide input[type="checkbox"]').length > 0) {
    $('.ile-custom-showhide').show();
    var engravingField = function ($obj) {
      if ($obj.prop('checked')) {
        $obj.closest('.ile-custom-showhide').next().show().find("input, textarea").val('').prop('required',true);
        $('.shopify-payment-button').hide();
      } else {
        $obj.closest('.ile-custom-showhide').next().hide().find("input, textarea").val('').prop('required',false);
        $('.shopify-payment-button').show();
      }
    }
    $('.ile-custom-showhide input[type="checkbox"]').each(function() {
		engravingField($(this));
    });
    $('.ile-custom-showhide input[type="checkbox"]').on('click',function(){
		engravingField($(this));
    });
  }

  $(document).on('click','.ile-add-product',function(){
    var href = $(this).attr("data-href") ? $(this).attr("data-href") : '',
        ids = $(this).attr("data-id").split(','),
        quas = $(this).attr("data-quantity") ? $(this).attr("data-quantity").split(',') : new Array(ids.length).fill(1),
        itemData = new Array();
    for (var i = 0; i < ids.length; i++) {
      itemData.push({'id': parseInt(ids[i], 10), 'quantity': parseInt(quas[i], 10)});
    }
    $(this).prop("disabled", $(this).attr("data-disabled") ? $(this).attr("data-disabled") : true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {'items': itemData},
      dataType: 'json', 
      success: function (data) {
        if (href) {
          window.location.href = href;
        }
      }
    });
    return false;
  });

  if ($('.ile-product-links').length > 0) {
    var $PL_Obj = $('.ile-product-links');
        
    $PL_Obj.find('button').on('click', function () {
      var $PL_Checked = $PL_Obj.find('input:checked'),
          PL_TagsParam = '',
          PL_ExistType = false,
          PL_ExistTag = false;
      $PL_Checked.each(function() {
        if ($(this).hasClass('type')) {
          PL_ExistType = true;
          PL_TagsParam = $(this).attr('value') + '/' + PL_TagsParam;
        } else {
          PL_ExistTag = true;
          PL_TagsParam += $(this).attr('value') + '%20';
        }
      });
      if (PL_ExistTag) {
        PL_TagsParam = PL_TagsParam.slice(0, -3);
      }
      if (typeof gtag !== 'undefined') {
    	  gtag('event', 'Search', {'event_category': 'Search', 'event_action': 'Search with tags', 'event_label': 'Searched '+ PL_TagsParam +''});
      }
      window.location.href = PL_ExistType ? PL_TagsParam : '/collections/all/' + PL_TagsParam;
    });
  }

  if ($('.ile-slide-pins').length > 0) {
    var setSlidePinsPosition = function() {
      var $slideWrapper = $('.ile-slide-pins').closest('.product-slideshow__content'),
          viewW = window.innerWidth,
          viewH = window.innerHeight - parseInt($slideWrapper.css('padding-bottom'));
      $('.ile-slide-pins').each(function() {
        var imgAspectoRaito = parseFloat($(this).parent().find('img').attr('data-aspectratio')),
        	isPortrateImg = imgAspectoRaito < 0,
            imgViewW = 0,
            imgViewH = 0;
        if (isPortrateImg) {
          imgViewW = Math.min(viewW, viewH * imgAspectoRaito);
          imgViewH = imgViewW / imgAspectoRaito;
        } else {
          imgViewH = Math.min(viewH, viewW / imgAspectoRaito);
          imgViewW = imgAspectoRaito * imgViewH;
        }
        $(this).css({width: imgViewW + 'px', height: imgViewH + 'px'});
      });
    }
    $(window).on("load resize orientationchange", setSlidePinsPosition);
    $(document).on('click','.product__media-wrapper, .product__submedia-wrapper', setSlidePinsPosition);
    $(document).on('click','.ile-slide-pins li', function() {
      if (!$(this).hasClass('on')) {
        $(this).parent().removeClass('ile-slide-pins-ani').find('li').removeClass('on');
        $(this).addClass('on');
        return false;
      }
    });
    $(document).on('click','.product-media--slideshow', function() {
      $(this).find('.ile-slide-pins li').removeClass('on');
    });
  }



  if ($('#shopify-section-slideshow.index-section').length > 0) {
    var autoplaySlidesNextPos = 1,
        autoplaySlidesHdl = setInterval(function() {
          var $slide = $('.slideshow__slide--active'),
              $button = $('.slideshow__button--active'),
              $slides = $('.slideshow__slide'),
              currentIndex = ($slides.index($slide) + 1) % $slides.length;
          if (currentIndex != autoplaySlidesNextPos) {
            clearInterval(autoplaySlidesHdl);
            return;
          }
          if ($('.slideshow__indicators').is(':visible')) {
            $('.slideshow__indicator').eq(currentIndex).trigger('click');
          } else {
            $('.slideshow__button button').eq(currentIndex).trigger('click');
          }
          autoplaySlidesNextPos = (currentIndex + 1) % $slides.length;
        }, 6000);
  }

})(jQuery);

(function() {
  if (typeof(productOptions) != "undefined") {
    for (i = 0; i < productOptions.length; i++) {
      const select = document.querySelectorAll('.single-option-selector')[i];
      const options = select.querySelectorAll('option');

      if (options.length > 1) {
        let option = new Option('Choose your option', '');

        select.add(option, select.firstChild);
        select.selectedIndex = 0;
      }
    }
  }
})();